import {CRISPRAssemblyPrimer} from 'constants/CRISPRConstants';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import {EntrySummary} from 'notebook/ELNConstants';
import * as net from 'util/Net';

export function createEntry(data: {
  name: string;
  folder: string;
  initialDay: string;
  assemblyPrimers: Array<CRISPRAssemblyPrimer>;
  assembledVectorIds: Array<string>;
}): JQueryPromise<EntrySummary> {
  return net.postJSON({url: '/1/api/crispr-assemblies/entry/', data}).done(() => {
    FolderDAOCache.invalidateFolderContents(data.folder);
  });
}
